<div class="score-legend-container">
    <span>Score</span>
    <span><div class="score-box" [class.red]="!validityScore" [class.green]="validityScore" ></div> {{validityScore?'0':'1'}}-3</span>
    <span><div class="score-box yellow"></div> 4-6</span>
    <span><div class="score-box "  [class.red]="validityScore" [class.green]="!validityScore"></div> 7-10</span>
</div>